<script>
  import { intcomma } from 'journalize';
import { raf } from 'svelte/internal';
  import { formatPercent } from '../utils/format.js';
  import Photos from './Photos.svelte';
  import lastNameDict from '../utils/nameDictionary';

   /** @type {string} */
  export let candidateGivenName;
    /** @type {string} */
  export let candidateFamilyName;
  /** @type {number} */
  export let candidateVotes;
  /** @type {number} */
  export let totalVotes;
  /** @type {boolean} */
  export let isIncumbent;
  /** @type {boolean} */
  export let isWinner;
  /** @type {string} */
  export let candidateParty;
  /** @type {string} */
  export let raceID;
    /** @type {boolean} */
  export let isRunoff;
  /** @type {boolean} */
  export let hasDroppedOut;

  /** @type {import('../types.d').Crosswalk} */
  export let lookup;

  $: barPercent = formatPercent(candidateVotes, totalVotes);
  $: wideBar = (candidateFamilyName.toLowerCase() == 'yes') || (candidateFamilyName.toLowerCase() == 'no') ? true : false;

  $: name = `${candidateGivenName} ${candidateFamilyName}`;
  /**
   * Text to slugify
   * @param {string} text
   */
  function slugify(text) {
    return text
      .toString()
      .toLowerCase()
      .replace(/\s+/g, '-') // Replace spaces with -
      .replace(/[^\w\-]+/g, '') // Remove all non-word chars
      .replace(/\-\-+/g, '-') // Replace multiple - with single -
      .replace(/^-+/, '') // Trim - from start of text
      .replace(/-+$/, ''); // Trim - from end of text
  }
</script>

{#if wideBar == false}
<td class="candidate__cell">
  <div class="candidate-headshot {slugify(name)}">
  {#if lookup}
    <Photos
      name = {name}
      src = {lookup.png}
      avif = {lookup.avif}
      webp = {lookup.webp}
      party = {candidateParty}
    />
  {/if}
  </div>
</td>
{/if}

<th scope="row" class="candidate__cell candidate__cell-name">
  <span class="candidate__cell-checkmark candidate__{candidateParty}" aria-label={isWinner ? 'checkmark, winner' : ''}> {isWinner ? `✓` : ''}</span>
  <div class="candidate_name {isWinner ? 'text-medium' : ''}">
    {#if hasDroppedOut}
      <span class="candidate__cell-dropped candidate">
        Dropped out
      </span><br>
    {/if}
    {#if candidateGivenName}<span class="desktop-only"
        >{candidateGivenName}</span
      >{/if}
    <span class="breakpoint"
      >{lastNameDict(candidateFamilyName)}
      {#if isRunoff}
      <span
        class="candidate__cell-runoff candidate__">
        Runoff
        </span>
      {/if}

      {#if isIncumbent}
        <span
          class="candidate__cell-incumbent"
          title="Currently holds this office"
          role="img"
          aria-label="incumbent">*</span
        >
      {/if}
    </span>
  </div>
</th>
<td class="candidate__cell bar-chart {raceID} {wideBar ?  'wide-bar' : ''}" aria-hidden="true">
  <div class="bar-container {raceID}">
    <div
      class="inner-bar
      {(candidateParty !== 'np')? candidateParty :
      (candidateFamilyName.toLowerCase() !== 'yes') && (candidateFamilyName.toLowerCase() !== 'no') ?  candidateParty : candidateFamilyName.toLowerCase()} {raceID}"
      style="width:{barPercent}%"
    />
  </div>
</td>
<td
  class="candidate__cell candidate__cell-pct {isWinner ? 'text-medium' : ''} text-right"
  aria-label="{formatPercent(candidateVotes, totalVotes)}%"
>
  {formatPercent(candidateVotes, totalVotes)}<span class="candidate__pct-symbol">%</span>
</td>
